/** @jsxImportSource @emotion/react */
import React from "react";
import { SerializedStyles, css } from "@emotion/react";
import { colors } from "../colors";
import { effects } from "../effects";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  additionalStyling?: SerializedStyles;
  overflowHidden?: boolean;
}

export const CardContainer = ({
  children,
  additionalStyling,
  overflowHidden = true,
  ...rest
}: Props) => {
  const containerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;
    gap: 16px;
    border-radius: 8px;
    margin-bottom: 24px;
    background-color: ${colors.white};
    box-shadow: ${effects.cardRest};
    ${overflowHidden && "overflow: hidden;"}
    ${additionalStyling}
  `;

  return (
    <div css={containerStyle} {...rest}>
      {children}
    </div>
  );
};
